import React from 'react'
import { useSearchParams } from 'react-router-dom';
import authApiService from '../../../services/authServices';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import Modal from "../../../utils/modalUtils";



const PostScheduleSeason = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const MRId = searchParams.get("id");

    const location = useLocation();
    const name = location.state?.name;

    console.log("nameee", name)

    /**
     * Handles form submission for scheduling post season
     * @param {Event} e - The form submit event
     */
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await authApiService.post(`postSchedule?seasonId=${MRId}`);

            if (response.code === 200) {
                Modal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Post Season scheduled successfully!",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#addd1e"
                }).then(() => {
                    navigate("/carter/manageRegistration");
                });
            } else {
                Modal.fire({
                    icon: "error",
                    title: "Failed",
                    text: "Something went wrong!",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#addd1e"
                });
            }
        } catch (error) {
            console.error("Error scheduling season:", error);
            Modal.fire({
                icon: "error",
                title: "Error",
                text: error.response?.data?.message || "Failed to schedule season.",
                confirmButtonText: "OK",
                confirmButtonColor: "#addd1e"
            });
        }
    };

    return (
        <div className="page-container col-sm-9">
            <h2 className='text-dark'>Set up the post season for the following groups</h2>
            <table cellSpacing={0} id="seasons" className="table" cellPadding={0}>
                <thead>
                    <tr>
                        <th className="sortable">
                            <a href="?id=62&d-1341130-s=0&d-1341130-o=2">Name</a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="odd">
                        <td style={{ whiteSpace: "nowrap" }}>
                            {name}
                        </td>
                    </tr>
                </tbody>
            </table>
            <form
                id="scheduleSeason"
                method="post"
                action="scheduleSeason.html"
                onsubmit="return onFormSubmit(this)"
            >
                <input
                    id="registrationId"
                    name="registrationId"
                    type="hidden"
                    defaultValue={62}
                />
                <div style={{ marginBottom: '15px' }}>
                        <button type='submit' className='green_btn' onClick={handleSubmit}>save</button>
                        <button type="button" className="gray_btn" style={{ marginLeft: '5px' }}
                            onClick={() => {
                                navigate("/carter/manageRegistration");
                            }}>
                            Cancle
                        </button>
                  </div>
            </form>
            {/* script type="text/javascript" src="/carter/scripts/validator.jsp"></script*/}
        </div>

    )
}

export default PostScheduleSeason